module.exports = __webpack_public_path__ + "img/lawyer.bd9ec833.png";